module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "CommonReviewsCollect"
  }, [_c('div', {
    staticClass: "rt-crm-CommonReviewsBtn",
    on: {
      "click": _vm.setCommonReviews
    }
  }, [_c('img', {
    staticClass: "rt-crm-Icon",
    attrs: {
      "src": "https://cdn2.fscloud.com.cn/$web/cdn2/saascrm/assets/imgs/new_collect.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$_t('收藏本条', 'approval.collection')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c45e35d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/vflow/CommonReviewsCollect.vue
// module id = 2049
// module chunks = 228